import * as React from 'react'
import { Form, Input, Button, message, notification } from 'antd'
import { UserOutlined, LockOutlined } from '@ant-design/icons'
import https from '@/utils/ajaxUtils'
import Urls from '@/config/url'
import config from '@/config/config'
import { Link } from 'react-router-dom'
import IndexHeader from '@/display/components/IndexHeader'
import IndexFooter from '@/display/components/IndexFooter'
class Register extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      submitting: false,
      extendFieldMap: null,
    }
  }
  render() {
    const login = async values => {
      console.log(values)
      let extendField = {
        userType: 0, //用户类型（默认个人）
        level: 0, //用户等级
        serviceCount: 0, //用户可使用服务次数
        integral: 0, //积分
      }
      let param = {
        mobile: values.mobile,
        password: values.registerPassword,
        confirmPassword: values.registerConfirmPassword,
        projectCode: config.projectCode,
        extendFieldMap: extendField,
      }
      // 调用接口登录
      this.setState({ submitting: true })
      const res = await https.post(Urls.register, param)
      console.log('res: ', res)
      console.log('参数：', param)
      this.setState({ submitting: false })
      if (res.success) {
        message.success('注册成功!')
        this.props.history.push(`/Login`)
      } else {
        notification['error']({
          message: '注册失败!',
          description: res.errMsg,
          duration: 2,
        })
      }
    }
    return (
      <div id="login" className="index">
        <IndexHeader />
        <div className="main">
          <div className="box">
            <div className="form">
              <div className="login-logo"></div>
              <div>
                <div className="title">注册</div>
                <div className="login-form">
                  <Form
                    name="login-form"
                    onFinish={login}
                    initialValues={{ remember: true }}
                  >
                    <Form.Item
                      name="mobile"
                      rules={[
                        {
                          required: true,
                          message: '请输入手机号',
                        },
                        {
                          pattern:
                            /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[189]))\d{8}$/,
                          message: '请输入合法的手机号!',
                        },
                      ]}
                    >
                      <Input
                        size={'large'}
                        placeholder="请输入手机号"
                        className="ipt"
                        prefix={<UserOutlined style={{ color: '#BFBFBF' }} />}
                      />
                    </Form.Item>
                    <Form.Item
                      name="registerPassword"
                      rules={[
                        {
                          required: true,
                          message: '请输入密码',
                        },
                        {
                          pattern:
                            /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,12}$/,
                          message: '8位到12位,首字母+数字',
                        },
                      ]}
                    >
                      <Input.Password
                        size={'large'}
                        placeholder="请输入密码"
                        className="ipt"
                        prefix={<LockOutlined style={{ color: '#BFBFBF' }} />}
                      />
                    </Form.Item>
                    <Form.Item
                      name="registerConfirmPassword"
                      dependencies={['registerPassword']}
                      hasFeedback
                      rules={[
                        {
                          required: true,
                          message: '请确认密码',
                        },
                        {
                          pattern:
                          /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,12}$/,
                          message: '8位到12位,首字母+数字',
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (
                              !value ||
                              getFieldValue('registerPassword') === value
                            ) {
                              return Promise.resolve()
                            }
                            return Promise.reject(
                              new Error('密码跟确认密码不一致!')
                            )
                          },
                        }),
                      ]}
                    >
                      <Input.Password
                        size={'large'}
                        placeholder="请确认密码"
                        className="ipt"
                        prefix={<LockOutlined style={{ color: '#BFBFBF' }} />}
                      />
                    </Form.Item>
                    <div className="acco" style={{ textAlign: '' }}>
                      <Link to={'/Login'}> {'>>已有账号,直接登录'}</Link>
                    </div>
                    <div className="btn">
                      <Button
                        type="primary"
                        htmlType="submit"
                        loading={this.state.submitting}
                      >
                        注&nbsp;&nbsp;册
                      </Button>
                    </div>
                    <br />
                  </Form>
                  {/* <div className="forget-password">忘记密码</div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <IndexFooter />
      </div>
    )
  }
}

export default Register
